// CSV export of the current view, one spreadsheet row per grid row.

import { STEP_ORDER, STEP_LABELS } from './deriveSession';
const cell = (value) => {
  const s = String(value ?? '');
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const fmtItems = (items) =>
  (items || []).map((i) => `${i.text} (${i.votes > 0 ? '+' : ''}${i.votes})`).join('; ');


// Appended below the grid when a guided case is running: the problem
// representation per revealed step, then the class gaps per revealed step.
function caseRows(cf) {
  if (!cf?.active) return [];
  const revealed = STEP_ORDER.filter((s) => (s === 'cdm' ? !!cf.diagnosisRevealedAt : !!cf.completed?.[s]));
  const rows = [];
  const pr = revealed.filter((s) => (cf.problemRepresentation?.[s] || '').trim());
  if (pr.length) {
    rows.push([], ['Problem representation', 'Step', 'Statement']);
    pr.forEach((s) => rows.push(['', STEP_LABELS[s], cf.problemRepresentation[s]]));
  }
  const gaps = revealed.filter((s) => cf.classGaps?.[s]?.items?.length);
  if (gaps.length) {
    rows.push([], ['Class gaps', 'Step', 'Expert item', 'Missed by', 'Listed by', 'Students counted']);
    gaps.forEach((s) => cf.classGaps[s].items.forEach((item) =>
      rows.push(['', STEP_LABELS[s], item.text, item.missed, item.listed, cf.classGaps[s].total])));
  }
  return rows;
}

export default function exportToCsv({ view, sessionId, cdmRows, diffRows, probabilityMode, caseFlow = null }) {
  let header;
  let rows;
  if (view === 'differential') {
    header = ['Etiological Class', 'Diseases', 'Supporting', 'Opposing'];
    rows = diffRows.map((r) => [
      fmtItems(r.etiologicalClass), fmtItems(r.diseases), fmtItems(r.supporting), fmtItems(r.opposing),
    ]);
  } else {
    header = ['Rank', 'Diagnosis', ...(probabilityMode ? ['Median probability %'] : []), 'Supporting', 'Opposing'];
    rows = cdmRows.map((r) => {
      const probMedians = (r.diagnoses || [])
        .map((d) => (d.prob?.median != null ? `${d.text}: ${d.prob.median}%` : null))
        .filter(Boolean)
        .join('; ');
      return [
        r.displayOrder,
        fmtItems(r.diagnoses),
        ...(probabilityMode ? [probMedians] : []),
        fmtItems(r.supporting),
        fmtItems(r.opposing),
      ];
    });
  }

  const csv = [header, ...rows, ...caseRows(caseFlow)].map((r) => r.map(cell).join(',')).join('\r\n');
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `cdm-grid-${sessionId}-${view}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
